<template>
  <div class="header-wrapper container-custom" v-bind:class="{'home-header-wrapper': $route.name === 'home'}">
    <HeaderDesktop :theme="$route.name === 'home' ? 'home-page' : ''"/>
  </div>
  <router-view></router-view>
  <div class="container-custom footer-container">
    <FooterMain/>
  </div>
  <ModalNotifications/>
</template>

<style lang="scss" scoped>

.header-wrapper {
  position: fixed;
  top: 2%;
  left: 0;
  z-index: 997;
  width: 100%;
  padding: 0 10px;
}


.footer-container {
  position: relative;
  padding-bottom: 50px;
}

@media screen and (min-width: 768px) {

  .home-header-wrapper {
    padding: 25px 80px!important;
  }
  .header-wrapper {
    /*
    padding: 0 100px;
    top: 45px
     */
    top: 24px;
    padding: 0 60px;
  }
}
</style>
<script>

import HeaderDesktop from "@/components/Components/HeaderDesktop/HeaderDesktop.vue";
import FooterMain from "@/components/Components/FooterMain/FooterMain.vue";
import ModalNotifications from "@/components/Components/ModalMain/ModalNotifications.vue";


export default {
  components: {
    ModalNotifications,
    HeaderDesktop,
    FooterMain
  },
  watch: {
    '$route'() {
      if (this.$route.meta) {
        const meta = this.$route.meta;
        document.title = this.$t('meta-title-base') + (meta.title ? " - " + meta.title : "");
      }
      this.$store.dispatch("utils/toggleOfficesModal", false);
      window.scrollTo({top: 0, left: 0, behavior: 'instant'});
    }
  },
}
</script>
